interface Props {
  readonly children: string;
}

export const NoSecondaryWrapper = ({ children }: Readonly<Props>) => (
  <>{children}</>
);
